class AccountDrawer extends HTMLElement {
    triggerSelector = '#user-icon'

    constructor() {
        super();
        this.validationMsg = JSON.parse(this.dataset.validationMsg.replaceAll('=>', ':'));
    }

    connectedCallback() {
        this.bindEvents();
    }

    bindEvents() {
        const drawerLink = document.querySelector(this.triggerSelector);
        if (!drawerLink || !this.querySelector('form'))
            return
        this.querySelector('#AccountDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        window.addEventListener('DOMContentLoaded', this.registerValidator.bind(this))
        this.setHeadeAccountIconAccessibility(drawerLink)
        drawerLink.addEventListener('click', (event) => {
            if (window.context?.customer?.email)
                return true;
            event.preventDefault();
            this.open(drawerLink);
        });
        drawerLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(drawerLink);
            }
        });
        window.waitForEl('shop-login-button', this)
            .then((shopPayBtn) => {
                shopPayBtn.addEventListener('click', (event) => {
                    const returnURI = event.target.getAttribute('return-uri') || '/account';
                    window.onChildMutate(shopPayBtn.shadowRoot, (obs) => {
                        obs.disconnect();
                        if (!shopPayBtn.shadowRoot.textContent)
                            window.location.href = returnURI;
                    });
                });
            });
    }

    /**
     * 
     * @param {HTMLElement} accountLink 
     */
    setHeadeAccountIconAccessibility(accountLink) {
        accountLink.setAttribute('role', 'button');
        accountLink.setAttribute('aria-haspopup', 'dialog');
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);

        setTimeout(() => {
            this.classList.add('animate', 'active');
        });

        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = this.querySelector('#AccountDrawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );

        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
        this.activeElement = element;
    }

    registerValidator() {
        const validator = nod();

        validator.add([{
            selector: '#ADCustomerPassword',
            validate: 'presence',
            errorMessage: this.validationMsg.password
        }, {
            selector: '#ADCustomerEmail',
            validate: 'email',
            errorMessage: this.validationMsg.email_address
        }, {
            selector: '#ADCustomerPassword',
            validate: 'min-length:5',
            errorMessage: this.validationMsg.password_short
        }])

        this.querySelector('form').addEventListener("submit", (event) => {
            validator.performCheck();
            if (validator.areAll('valid'))
                return;
            event.preventDefault();
        })
    }
}

customElements.define('account-drawer', AccountDrawer)